// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_CarregaInfosGraficoResumoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/carrega_infos_grafico_resumo
 *
 * Returns summary statistics for the dashboard.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface GestaoClientes_CarregaInfosGraficoResumoResponseDados {
qtd_clientes_sem_orcamento: number
qtd_orcamentos_sem_compromisso: number
valor_total_orcamentos_sem_compromisso: number
}

export type GestaoClientes_CarregaInfosGraficoResumoResponse = ApiResponse<GestaoClientes_CarregaInfosGraficoResumoResponseDados>;

registerResponseContract('GestaoClientes_CarregaInfosGraficoResumoResponse', {
  qtd_clientes_sem_orcamento:             { type: 'number',  required: true },
  qtd_orcamentos_sem_compromisso:         { type: 'number',  required: true },
  valor_total_orcamentos_sem_compromisso: { type: 'number',  required: true },
})
